import { useGetDocumentInvoiceFilterDimensions } from "hooks/api/documents/documentFilterDimensions";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { removeNullable } from "services/apiHelpers";
import {
  CheckboxListFilter,
  FilterOption,
} from "../GenericFilters/CheckboxListFilter";
import { FilterProps } from "../filter-definition";

export const InvoicesShipToFilter = ({ variant }: FilterProps) => {
  const cardCodes = useSelectedCustomerCode();

  const { data, isLoading } = useGetDocumentInvoiceFilterDimensions(cardCodes);

  const shipToOptions: FilterOption[] = removeNullable(
    data?.shipToAddresses?.map((shipTo) => ({
      label: shipTo.Name,
      value: shipTo.Code,
    })) ?? []
  );

  return (
    <CheckboxListFilter
      filterKey="shipTo"
      name="Ship To"
      variant={variant}
      filterOptions={shipToOptions}
      isLoading={isLoading}
    />
  );
};
